import React from "react";
import { motion } from "framer-motion";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../modals/AnimatedModal";
import PaymentMethodsList from "./PaymentMethodsList";
import PaymentsIcon from "@mui/icons-material/Payments";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { delay: 0.1, duration: 0.4 },
  },
};

export default function PaymentMethodsModal({ show, closeModal }) {
  return (
    <AnimatedModal
      isOpen={show}
      onClose={closeModal}
      width="60%"
      maxWidth="1000px"
    >
      <ModalHeader
        title="Métodos de Pagamentos"
        icon={PaymentsIcon}
        onClose={closeModal}
      />
      <ModalContent padding={0}>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <PaymentMethodsList />
        </motion.div>
      </ModalContent>
    </AnimatedModal>
  );
}
